// extracted by mini-css-extract-plugin
export default {"strip":"tGc0nm","root":"yF4oyk","compareLink":"DsIC1C","compareButton":"NhDft9","leftToRight":"ouCM2C"};